export const GOLFTECH_TYPES = {
    ORGANIZER: 'Organizer',
    COURSE: 'Course',
    GOLFER: 'Golfer',
    GLOBAL_ADMIN: 'GlobalAdmin'
}
